import {
  CapacitorBarcodeScanner, CapacitorBarcodeScannerAndroidScanningLibrary, CapacitorBarcodeScannerTypeHintALLOption,
} from '@capacitor/barcode-scanner';
import { toast } from 'sonner';
import { IS_NATIVE, WORKSPACE_ORIGIN } from '../config/runtime';

/**
 * One barcode / QR scan with the phone's camera, returning its text — or null
 * when the operator backed out. Any format: QR, Code 128 / 39, EAN, Data
 * Matrix — whatever is printed on a carton or lot tag. The plugin brings its
 * own full-screen scanner and asks for the camera the first time.
 */
export async function scanCode() {
  if (!IS_NATIVE) return null;
  try {
    const res = await CapacitorBarcodeScanner.scanBarcode({
      hint: CapacitorBarcodeScannerTypeHintALLOption.ALL,
      scanInstructions: 'Point the camera at the barcode or QR code',
      android: { scanningLibrary: CapacitorBarcodeScannerAndroidScanningLibrary.MLKIT },
    });
    const text = (res?.ScanResult || '').trim();
    return text || null;
  } catch (err) {
    const msg = String(err?.message || err);
    if (/cancel/i.test(msg)) return null;
    if (/permission|denied/i.test(msg)) {
      toast.error('Camera access is off for Aqua ERP. Turn it on in the phone settings to scan.');
      return null;
    }
    toast.error('Could not scan. Try again.');
    return null;
  }
}

/** Same code written as `K401-B001`, `k401 b001`, `K401B001`. */
export const normalizeCode = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '');

/**
 * A scanned QR may be a link (a label printed with the record's URL). If it
 * points into this workspace — or is a bare path — return the in-app path to
 * open; anything else is treated as a code to search for.
 */
export function inAppPathFromScan(text) {
  if (!text) return null;
  if (text.startsWith('/')) return text;
  try {
    const u = new URL(text);
    const ours = WORKSPACE_ORIGIN ? new URL(WORKSPACE_ORIGIN).host : window.location.host;
    if (u.host === ours) return `${u.pathname}${u.search}${u.hash}` || '/';
  } catch {
    /* not a URL — a code */
  }
  return null;
}

// GlobalSearch listens for this and opens with the scanned code typed in.
export const SCAN_SEARCH_EVENT = 'erp:scan-search';
